import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { initGoogleClient } from "../../../../../shared/googleAuth/googleAuthentication";
import { ConfirmationService } from "primeng/primeng";
import { MessageService } from "primeng/components/common/messageservice";
import {
  addSubjectsModel,
  addSubSecModel,
} from "../../../../../components/dataAnalytics/dataAnalytics.model";
import { addSubSubjectsModel } from "../../../../../components/dataAnalytics/dataAnalytics.model";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
declare var gapi: any;

@Component({
  selector: "subSubjectsS",
  templateUrl: "subSubjectsS.component.html",
  styleUrls: ["subSubjectsS.component.scss"],
})
export class SubSubjectsSComponent implements OnInit {

  display = "none";
  display1 = "none";
  public schoolId: any;
  public data: any = [];
  public userdetailes = [];
  public mappedData: any;
  public newSectionArray = [];
  public adminUserFlag: boolean;
  public schoolUserFlag: boolean;
  public selectAllSectionFlag: boolean;
  public selectedStd = [];
  public selectedStd1 = [];
  public guru: any = [];
  public subName: any;
  public subId: any;
  public payload: any;
  public Gs: any;
  public Es: boolean = false;
  public selectSectionCount: number = 0;
  public standardName: any;
  public sectionName: any;
  public guru1: any = [];
  public ShowSubjectSecData: any = [];
  public showdata: any = [];
  public showdata1: any = [];
  public view: boolean = false;
  public Subjectid: any;
  public Subjectname: any;
  public userId: string;
  loading = "none";
  selectedSubject: string = "All Subjects";
  subjects: any = [];
  LevelsData: any = [];
  public selectedLevels: any;
  subSubjectData: any = [];
  selectedSubSubject: any;
  selectedsection:any;
  selectedGrade:any;
  public SubsubjectId:any;
  public ShowSubSubjectData: any = [];

  addSubSubjectName : any;
  addSubSubjectWeight : any;
  selectedSubSubjectName : any;
  selectedmaxmark : any;
  selectedValue : any;
  selectedSubSubjectId: any;


  subSubjectTempData: any = [];
  totalTempPercentageForSubject: number;

  constructor(
    private dataAnalyticsService: DataAnalyticsService,
    private messageService: MessageService,
    private noticeboardService: NoticeboardService,
    private confirmationService: ConfirmationService,
    private localStorage: LocalStorageService
  ) {
    this.schoolId = this.localStorage.retrieve("SchoolId");
    this.userId = this.localStorage.retrieve("id");
  }
  ngOnInit() {
    // this.getSubjects();
    this.adminUserFlag = this.localStorage.retrieve("IsSchoolAdminUser");
    this.schoolUserFlag = this.localStorage.retrieve("Isschooluser");
    if (this.adminUserFlag || this.schoolUserFlag) {
    } else {
    }

    this.selectedStd = new Array<string>();

    if (this.adminUserFlag == true) {
      this.schoolUserFlag = false;
    }
    this.getLevels();
  }

  /* -----------------------------GET SUBJECT--------------------------------*/
  public getSubjects(sid) {
    console.log('Getsubject',sid);
    this.dataAnalyticsService
      .getSubjects(sid)
      .finally(() => {})
      .subscribe(
        (response) => {
          let mappedData: any = response;
          this.subjects = [
            /*{SubjectName: 'All Subjects', SubjectId: 'all-subjects'}*/
          ];
          this.subjects.push(...mappedData["subsemList"][0]);

          try {
            this.selectedSubject = this.subjects[0];
            this.getSubSubjects(this.selectedSubject["SubjectId"]);
          } catch (error) {}
          //this.onSubjectOrClassGradeChange(this.selectedSubject, this.selectedGCl);
          console.log("getSubjects", mappedData);
        },
        (error) => {}
      );
  }
  /* -----------------------------GET sub SUBJECT--------------------------------*/
  private getSubSubjects(subid) {
    this.dataAnalyticsService
      .GetSubSubjects(subid)
      ._finally(() => {
        this.loading = "none";
      })
      .subscribe((response) => {
        console.log("getSubSubjects", response);
        this.subSubjectData = response;
        try {
          this.selectedSubSubject = this.subSubjectData[0];

          if (this.selectedSubSubject.SubjectId == "all-subjects") {
            //this.GetStudentsChartOverallPrecentageRank(childidx);
            //return;
          } else if (this.selectedSubSubject.SubjectId != undefined) {
            //this.getSubSubjectRankByClass();
          }
        } catch (error) {}
      });
  }

  /* -----------------------------GET LEVEL-CLASS--------------------------------*/
  private getLevelClassSection(lid) {
    this.dataAnalyticsService
      .GetLevelStandardSectionMapping(lid)
      .finally(() => {})
      .subscribe(
        (response) => {
          let mappedData: any = response;
          mappedData.forEach((standard) => {
            standard["Sections"].forEach((section) => {
              section["StdId"] = standard["standardId"];
              section["StdName"] = standard["standardsName"];
              section["selected"] = false;
            });
          });
          console.log("mappedData", mappedData);
          mappedData.sort((a, b) =>
            ("" + a.standardsName).localeCompare(b.standardsName, undefined, {
              numeric: true,
            })
          );
          if (true) {
            this.mappedData = mappedData;
            try {
              this.selectedGrade =  this.mappedData[0];
              this.selectedsection = this.mappedData[0].Sections[0];
              this.getSubjects(this.selectedsection.SectionId);
            } catch (error) {

            }
          }
        },
        (error) => {}
      );
  }

  onSubjectOrClassGradeChange(subject) {
    console.log("onSubjectOrClassGradeChange",subject);

    this.getSubSubjects(subject.SubjectId);
  }
  getSectionByGrade(grade) {
    try {
      this.selectedsection = grade.Sections[0];
      this.getSubjects(this.selectedsection.SectionId);
    } catch (error) {

    }
  }
  getSectionBy
  private getLevelsListById(level) {
    console.log("getLevelsListById", level);
    this.getLevelClassSection(level["Id"]);
  }

  /* -----------------------------GET LEVEL--------------------------------*/
  private getLevels() {
    this.dataAnalyticsService
      .GetLevels()
      ._finally(() => {
        this.loading = "none";
      })
      .subscribe((response) => {
        console.log("getLevels", response);
        this.LevelsData = response;
        try {
          this.selectedLevels = this.LevelsData[0];
          this.getLevelClassSection(this.selectedLevels["Id"]);
        } catch (error) {}
      });
  }


  addSubSubject() {
    //for clearing checkbox
    this.mappedData.forEach((element) => {
      element.checkFlag = false;
      this.selectedStd.push(element);
      console.log(element);
    });
    this.Es = false;
    this.Gs = false;
    this.selectedStd.forEach((element) => {
      // console.log(element)
      element.selectedFlag = false;
      this.selectedStd.forEach((element1) => {
        element1.Sections.forEach((element2) => {
          element2.selected = false;
        });
      });
    });
    this.display = "block";
    this.selectedStd = [];

    this.selectedSubSubjectName = '';
    this.selectedSubSubjectId = '';
    this.addSubSubjectWeight = '';
    this.selectedmaxmark = '';


  }

  editSubSubject(subsubject: any) {
    //this.selectedSubSubject = subsubject;
    this.selectedSubSubjectName = subsubject.SubSubject;
    this.selectedSubSubjectId = subsubject.Id
    this.addSubSubjectWeight = subsubject.Precentage;
    this.selectedmaxmark = subsubject.SubMaxMarks;
    this.display1 = 'block';
  }


  // <------------------------------ post sub Subjects ----------------------------------------->

  public async postSubSubjects() {
    if(this.selectedLevels == null || this.selectedLevels.Id == null ||
      this.selectedGrade == null || this.selectedGrade.Id == null){

    }

    let actualSubjectId = (this.selectedSubject as any).SubjectId;

    // Create payload object
    let payload = {
      "SubSubjectName": this.selectedSubSubjectName,
      "SubjectId": actualSubjectId,
      "Percentage": this.addSubSubjectWeight,
      "SubMaxMarks": this.selectedmaxmark,
      "ExcelSheetOrder": this.selectedValue

    };

    console.log(payload);

    try {
      this.loading = "loading";
      const response = await this.dataAnalyticsService.GetSubSubjects(actualSubjectId).toPromise();
      this.subSubjectTempData = response;
      console.log("getSubSubjects", this.subSubjectTempData);

      this.totalTempPercentageForSubject = 0; // Initialize the total percentage to 0

      this.subSubjectTempData.forEach(element => {
        this.totalTempPercentageForSubject += Number(element.Precentage);
        // console.log(percentage);
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = "none";
    }

    // console.log(this.totalTempPercentageForSubject);


    // console.log("with addtion",this.totalTempPercentageForSubject+Number(payload.Percentage));


    if ((this.totalTempPercentageForSubject+Number(payload.Percentage)) <= 100) {
      // console.log('can proceed')
      this.dataAnalyticsService.postSubSubject(payload).subscribe(
        response => {
          console.log(response);
          let res: any = response;
          // Success message
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "Sub subject successfully added.",
          });


          this.getSubSubjects(this.selectedSubject["SubjectId"]);

        },
        error => {
          console.log(error);
          this.messageService.add({
            severity: "error",
            summary: "Talkative Parents",
            detail: "Failed to add Sub subject",
          });
        }
      );
    }else{
      this.messageService.add({
        severity: "error",
        summary: "Talkative Parents",
        detail: "The sum of weights exceeds 100",
      });
    }
    this.display = "none";
  }
  // <------------------------------ Update sub Subjects ----------------------------------------->

  public async UpdateSubjects() {

    // Check if all values are available, or do nothing / show error
    //if (this.selectedSubSubjectId && this.selectedSubSubjectName && this.selectedWeightage && this.selectedmaxmark) {

    let actualSubjectId = (this.selectedSubject as any).SubjectId;


    let payload = {
      "Id": this.selectedSubSubjectId,
      "SubSubjectName": this.selectedSubSubjectName,
      "Percentage": this.addSubSubjectWeight,
      "SubMaxMarks": this.selectedmaxmark
    };

    console.log(actualSubjectId);

    try {
      this.loading = "loading";
      const response = await this.dataAnalyticsService.GetSubSubjects(actualSubjectId).toPromise();
      this.subSubjectTempData = response;
      console.log("getSubSubjects", this.subSubjectTempData);

      this.subSubjectTempData = this.subSubjectTempData.filter(subSubject => subSubject.Id !== this.selectedSubSubjectId);

      console.log("getSubSubjects", this.subSubjectTempData);

      this.totalTempPercentageForSubject = 0; // Initialize the total percentage to 0

      this.subSubjectTempData.forEach(element => {
        this.totalTempPercentageForSubject += Number(element.Precentage);
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = "none";
    }

    console.log(this.totalTempPercentageForSubject);
    console.log(this.totalTempPercentageForSubject + Number(this.addSubSubjectWeight));

    if (this.totalTempPercentageForSubject + Number(this.addSubSubjectWeight) <= 100) {
      this.dataAnalyticsService.updateSubSubject(payload).subscribe(
        response => {
          console.log(response);
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "Sub subject successfully Updated.",
          });

          this.getSubSubjects(this.selectedSubject["SubjectId"]);
        },
        error => {
          console.log(error);
          this.messageService.add({
            severity: "error",
            summary: "Talkative Parents",
            detail: "Failed to Update Sub subject",
          });
        }
      );
    }else{
      this.messageService.add({
        severity: "error",
        summary: "Talkative Parents",
        detail: "The sum of weights exceeds 100",
      });
    }
    this.display1 = "none";
  }

  edit() {
    this.ShowSubjectSecData.forEach((ele) => {
      console.log(ele);
      ele.Standards.forEach((standardArr) => {
        standardArr.Sections.forEach((element1) => {
          element1.selected = true;
        });

      });
    });

  }


  onCloseHandled() {
    this.display = "none";
  }

  onCloseHandled1() {
    this.display1 = "none";
  }


}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/SubSubjectsS/subSubjectsS.component.ts